import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { usePostMessageContext } from '../post-message/PostMessage';
import { usePostMessageHandler } from './usePostMessageHandler';

export const useInitializeMenu = menu => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { entityRef } = useParams();

  const { sendMessage } = usePostMessageContext();

  React.useEffect(() => {
    sendMessage({ locationChange: pathname });
  }, [pathname, sendMessage]);

  const handleMessageEvent = React.useCallback(
    event => {
      const message = event?.data;
      if (message?.menuItemClicked) {
        const destination = `${entityRef ? `/${entityRef}` : ''}${message.menuItemClicked.path}`;
        if (destination !== pathname) {
          console.log('navigate 26', destination);
          navigate(destination);
        }
      }
    },
    [entityRef, navigate, pathname]
  );

  usePostMessageHandler(handleMessageEvent);
};
